import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { fomatTime } from 'src/app/utils';
import { WSSState } from 'src/app/wss/wss.model';
import { myId } from 'src/app/wss/wss.selectors';
import { WSSService } from 'src/app/wss/wss.service';
import { PagesState } from '../../pages.model';
import { callWaiting, gotQueue } from '../../pages.selectors';

@Component({
  selector: 'call-queue',
  templateUrl: './queue.component.html',
  styleUrls: ['./queue.component.scss']
})
export class QueueComponent {
  calls: any[] = []
  waiting: string[] = []
  interval: any
  bShowHangUp: boolean = false;
  my_id: string = "";
  subscriptions: any[] = []

  constructor(
    public pagesState: Store<PagesState>,
    public wss_service: WSSService,
    public wssState: Store<WSSState>,
  ) {

    this.subscriptions.push(this.wssState.select(myId).subscribe((my_id: any) => {
      this.my_id = my_id
    }))
    this.subscriptions.push(this.pagesState.select(gotQueue).subscribe((queue: any[]) => {
      this.calls = [];
      queue.forEach((c: any) => {
        if (c.state == "calling") {
          this.calls.push(c)
        }
      })
      if (this.calls.length) {
        this.setDuration()
        if (!this.interval) {
          this.interval = setInterval(() => this.setDuration(), 1000)
        }
      }
    }))
    console.log("queue")
  }
  ngOnDestroy() {
    this.subscriptions.forEach((s) => {
      s.unsubscribe();
    })
    clearInterval(this.interval)
  }
  setDuration() {
    let now = new Date().getTime()
    let calls: any[] = []//Object.assign([], this.calls)
    let waiting: string[] = []
    for (let i = 0; i < this.calls.length; i++) {
      let call: any = Object.assign({}, this.calls[i])
      let call_waiting: string = ""
      if (call.state == "calling") {
        if (call.start_calling_at) {
          call_waiting = fomatTime(now - call.start_calling_at)
        } else {
          call_waiting = "error"
        }
        waiting.push(call_waiting)
      }
      // else {
      //   waiting = "conected"
      // }
      if (call.rep_id) {
        if (call.rep_id == this.my_id) {
          this.bShowHangUp = true
        }
      }

    }
    this.waiting = waiting
  }

  answer(i: number) {
    // let msg = { answer: this.calls[i].caller_id }
    this.wss_service.answer(this.calls[i])
    // this.wss_service.sendMessageToMembersAndMe(msg)
  }
  hangUp(i: number) {

  }
}
